import useVoipCurrentQuery from "@/shared/queries/voip/useVoipCurrentQuery";
import Icon from "../Icon/Icon";
import Skeleton from "react-loading-skeleton";
import { getUserAddress } from "@/shared/utils/helpers";
import useVoipApproveHandlerHook from "@/shared/hooks/useVoipApproveHandlerHook";

const VoipCallToast = () => {
  const { data } = useVoipCurrentQuery();
  const handleApprove = useVoipApproveHandlerHook();

  return (
    <div onClick={handleApprove} className="m-[-1.25rem] flex h-40 gap-4">
      <div className="flex flex-[1_0_20%] flex-col items-center justify-center gap-1" style={{ borderRight: "3px solid #ccc" }}>
        <Icon className="h-[1.8rem] w-[1.8rem] fill-success" variants="phone" />
      </div>

      <div className="flex-[1_0_80%]">
        {data === undefined ? (
          <div className="mr-[2.2rem] mt-[1rem]">
            <Skeleton height="7rem" />
          </div>
        ) : (
          <>
            <div>{data?.users?.[0]?.name || ""}</div>
            <div>{data?.users?.[0]?.telephone || ""}</div>
            <div>{getUserAddress(data?.users?.[0] || {})}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default VoipCallToast;
